import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide12HiddenValue() {
  const stages = ['Question Design', 'Behavioral Response', 'Audience Segmentation', 'Buying Criteria', 'Capability vs Perception', 'Strategic Recommendations'];
  const examples = [{
    text: 'Safety vs efficacy preference',
    x: '8%',
    y: '18%'
  }, {
    text: 'Trust signals',
    x: '76%',
    y: '15%'
  }, {
    text: 'Innovation readiness',
    x: '15%',
    y: '78%'
  }, {
    text: 'Scientific credibility',
    x: '70%',
    y: '82%'
  }, {
    text: 'Speed vs scale',
    x: '42%',
    y: '12%'
  }, {
    text: 'Simplicity vs sophistication',
    x: '50%',
    y: '88%'
  }];
  return <div className="w-full h-full flex flex-col max-w-[90rem] mx-auto pt-10 relative" data-id="element-365">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center mb-4" data-id="element-366">
        <div className="inline-block px-3 py-1 rounded-full bg-snakker-secondary/10 border border-snakker-secondary/20 text-xs font-mono uppercase tracking-widest text-snakker-secondary mb-6" data-id="element-367">
          Strategic Market Intelligence
        </div>
        <h2 className="text-[clamp(2.5rem,4vw,4rem)] font-light tracking-tight text-snakker-ink mb-3" data-id="element-368">
          Every interaction is{' '}
          <span className="text-gradient-accent font-medium" data-id="element-369">
            market research.
          </span>
        </h2>
        <p className="text-lg text-snakker-muted font-light" data-id="element-370">
          Smart questions reveal what the market truly values.
        </p>
      </motion.div>

      <div className="flex-1 relative flex items-center justify-center px-4" data-id="element-371">
        {/* Floating examples */}
        {examples.map((ex, i) => <motion.div key={i} className="absolute px-3 py-1.5 rounded-full bg-white border border-snakker-border shadow-sm text-xs text-snakker-muted z-0" style={{
        left: ex.x,
        top: ex.y
      }} initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 0.85,
        scale: 1
      }} transition={{
        delay: 1.5 + i * 0.15
      }} data-id="element-372">
            {ex.text}
          </motion.div>)}

        {/* Flow stages */}
        <div className="relative z-10 flex items-center justify-between gap-2 w-full max-w-[80rem]" data-id="element-373">
          {stages.map((stage, i) => <Fragment key={i} data-id="element-374">
              <motion.div className="flex flex-col items-center" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.15 + 0.4
          }} data-id="element-375">
                <div className="w-12 h-12 rounded-xl bg-white border border-snakker-border shadow-sm flex items-center justify-center mb-3 relative" data-id="element-376">
                  <span className="font-mono text-xs text-snakker-primary font-semibold" data-id="element-377">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  {i >= 2 && <motion.div className="absolute inset-0 rounded-xl border border-snakker-primary/40" animate={{
                scale: [1, 1.3],
                opacity: [0.6, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2
              }} data-id="element-378" />}
                </div>
                <div className="text-center max-w-[8rem]" data-id="element-379">
                  <div className="text-sm font-medium text-snakker-ink leading-tight" data-id="element-380">
                    {stage}
                  </div>
                </div>
              </motion.div>
              {i < stages.length - 1 && <motion.div initial={{
            opacity: 0,
            scale: 0
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: i * 0.15 + 0.5
          }} className="text-snakker-ink/20 -mt-8" data-id="element-381">
                  <ArrowRight className="w-4 h-4" data-id="element-382" />
                </motion.div>}
            </Fragment>)}
        </div>
      </div>

      <motion.div className="text-center pb-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2.5
    }} data-id="element-383">
        <p className="text-lg font-light tracking-wide text-snakker-muted" data-id="element-384">
          The audience tells you how they think —{' '}
          <span className="text-snakker-ink font-medium" data-id="element-385">
            if the questions are designed correctly.
          </span>
        </p>
      </motion.div>
    </div>;
}